import { I18n } from '@calendly/i18n'
import { SimplePopup } from '@calendly/ui/components/popup'
import { BodyText } from '@calendly/ui/components/typography'

export const ConfirmExitModal = ({ isOpen, onClose, onConfirm, title, text }) => (
  <SimplePopup
    isDestructive
    isOpen={isOpen}
    onClose={onClose}
    onConfirm={onConfirm}
    title={title}
    cancelLabel={I18n.t('publisher.action.nevermind')}
    confirmLabel={I18n.t('publisher.organization_settings.test_saml_settings.exit_setup')}
  >
    {text && <BodyText>{text}</BodyText>}
  </SimplePopup>
)
